"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CreateButton = function (props) {
    var className = (0, classnames_1.default)("create-button", "center", { "create-button--active": props.isActive }, props.className);
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { "aria-label": props.label, isRound: true, size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Add, null), type: kaleidoscope_1.ButtonType.Secondary, className: className, onClick: props.onClick, onMouseDown: props.onMouseDown }));
};
exports.default = CreateButton;
